import { render, staticRenderFns } from "./message-group-system.vue?vue&type=template&id=375d9ca0&scoped=true"
import script from "./message-group-system.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-group-system.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-group-system.vue?vue&type=style&index=0&id=375d9ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d9ca0",
  null
  
)

export default component.exports